(function () {
  if (window.SBPrimeCuesCartMasterV23) return;
  window.SBPrimeCuesCartMasterV23 = true;

  var UPSELL_IDS = [
    '46931441090697',
    // '46931704348809', // Compostable Packaging - tam tat
    '46931722240137'
  ];

  // Mo ta hien duoi ten upsell trong main cart (gan qua line item property).
  // Key = variant id, value = cau mo ta giong trong drawer.
  var UPSELL_DESCRIPTIONS = {
    '46931441090697': 'Protect your order from loss, theft, or damage.',
    '46931704348809': 'Upgrade your order with eco-friendly packaging.',
    '46931722240137': 'Move your order to the front of our production queue.'
  };

  var addSubmitting = false;
  var syncing = false;
  var syncTimer = null;
  var cleaning = false;

  function isCartPage() {
    return location.pathname === '/cart' || location.pathname.endsWith('/cart');
  }

  function isUpsellId(id) {
    return UPSELL_IDS.indexOf(String(id)) !== -1;
  }

  function getCart() {
    return fetch('/cart.js?_sb_v23=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    }).then(function (res) { return res.json(); });
  }

  function updateCart(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) { return res.json(); });
  }

  function hasNormalProduct(cart) {
    return (cart.items || []).some(function (item) {
      return !isUpsellId(item.variant_id);
    });
  }

  function hasUpsell(cart) {
    return (cart.items || []).some(function (item) {
      return isUpsellId(item.variant_id);
    });
  }

  function findCartItem(cart, variantId) {
    return (cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  function isEmptyState(cart) {
    return !cart || cart.item_count === 0 || !hasNormalProduct(cart);
  }

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2) + ' USD';
  }

  function updateBadge(cart) {
    var count = cart.item_count || 0;
    var text = String(count);
    document.querySelectorAll(
      '[data-cart-count], [data-header-cart-count], ' +
      '.cart-count-bubble span:not(.visually-hidden), ' +
      '.xo-cart-count, .xo-cart-mini-count, .xo-cart-size, ' +
      'xo-cart-size, .xo-header-cart__count, .xo-header__cart-count'
    ).forEach(function (el) {
      el.textContent = text;
    });
  }

  function updateTotals(cart) {
    var totalText = money(cart.total_price || 0);
    // main cart total cua XO
    document.querySelectorAll('.xo-cart-totals__value').forEach(function (el) {
      el.textContent = totalText;
    });
    // drawer total cua XO
    document.querySelectorAll('.xo-side-cart__price-number span, .xo-side-cart__price-number').forEach(function (el) {
      if (el.children.length <= 1) el.textContent = totalText;
    });
    // selector du phong khac
    document.querySelectorAll(
      '[data-sb-cart-total], [data-cart-total], [data-cart-subtotal], ' +
      '.xo-cart-mini-footer__price, .xo-cart-mini-drawer-footer__price'
    ).forEach(function (el) {
      if (el.children.length <= 1) el.textContent = totalText;
    });
  }

  function getUpsellRoots() {
    return document.querySelectorAll('#SB-CartUpsells, [data-sb-cart-upsells], .sb-cart-upsells');
  }

  // Trong main cart + drawer, dong upsell (xo-product) hien "Title: Default Title".
  // An sach dong do (khong chen gi them).
  function decorateUpsellRows() {
    UPSELL_IDS.forEach(function (id) {
      document.querySelectorAll('xo-product[xo-product-id="' + id + '"]').forEach(function (prod) {
        if (prod.closest('#SB-CartUpsells, [data-sb-cart-upsells], .sb-cart-upsells')) return;

        var content = prod.querySelector('.xo-cart-item__content') || prod;

        // an moi node "la" chua "Default Title"
        content.querySelectorAll('*').forEach(function (el) {
          if (el.children.length) return;
          if (/Default Title/i.test(el.textContent || '')) {
            var line = el.closest('[class*="option"], [class*="variant"], [class*="property"], [class*="title"]') || el.parentElement || el;
            line.style.display = 'none';
          }
        });
      });
    });
  }

  // An toast loi "line parameter is invalid" cua XO (neu lo phat sinh)
  function dismissXoLineErrors() {
    document.querySelectorAll('*').forEach(function (el) {
      if (el.children.length) return;
      var t = (el.textContent || '').trim();
      if (/line parameter is invalid/i.test(t)) {
        var toast = el.closest('[class*="toast"], [class*="notification"], [class*="alert"], [class*="message"], [class*="error"]') || el.parentElement;
        if (toast) toast.style.display = 'none';
      }
    });
  }

  // Bat toast ngay khi XO chen vao DOM -> an truoc khi user kip thay
  function watchForLineErrors() {
    try {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            var txt = (node.textContent || '');
            if (/line parameter is invalid/i.test(txt)) {
              node.style.display = 'none';
              var toast = node.closest && node.closest('[class*="toast"], [class*="notification"], [class*="alert"], [class*="message"], [class*="error"]');
              if (toast) toast.style.display = 'none';
            }
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  function syncUpsellToggles(cart) {
    var empty = isEmptyState(cart);
    getUpsellRoots().forEach(function (root) {
      root.classList.add('sb-ready');
      root.style.display = empty ? 'none' : '';
      root.querySelectorAll('[data-upsell-item]').forEach(function (row) {
        var id = String(row.getAttribute('data-variant-id') || '').trim();
        row.classList.toggle('is-active', !!findCartItem(cart, id));
      });
    });
    decorateUpsellRows();
  }

  // ----- Cleanup khi cart CHI con upsell: xoa TUAN TU bang nut remove cua XO -----
  // Phai dung dung co che XO (click remove) de khong loi xo-line.
  // Sau moi click, doi dung dong do BIEN MAT khoi DOM roi moi click cai tiep theo.
  function findUpsellProduct() {
    for (var i = 0; i < UPSELL_IDS.length; i++) {
      var el = document.querySelector('xo-product[xo-product-id="' + UPSELL_IDS[i] + '"]');
      if (el && !el.closest('#SB-CartUpsells, [data-sb-cart-upsells], .sb-cart-upsells')) {
        return el;
      }
    }
    return null;
  }

  function removeOneUpsell() {
    var prod = findUpsellProduct();
    if (!prod) return Promise.resolve(false); // het roi

    var remove = prod.querySelector('xo-cart-remove, [xo-cart-remove], .xo-cart-remove');
    if (!remove) return Promise.resolve(false);

    return new Promise(function (resolve) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        if (mo) mo.disconnect();
        clearTimeout(t);
        resolve(true);
      }

      // theo doi den khi xo-product nay bi go khoi DOM
      var mo = null;
      try {
        mo = new MutationObserver(function () {
          if (!document.body.contains(prod)) finish();
        });
        mo.observe(document.body, { childList: true, subtree: true });
      } catch (e) {}

      // timeout an toan (neu observer khong bat duoc)
      var t = setTimeout(finish, 700);

      remove.click();
    });
  }

  function removeAllUpsellsSequential() {
    return removeOneUpsell().then(function (removed) {
      dismissXoLineErrors();
      if (removed) return removeAllUpsellsSequential();
      return true;
    });
  }

  function cleanupOnlyUpsells(cart) {
    if (!cart.items || !cart.items.length) return Promise.resolve(cart);
    if (hasNormalProduct(cart)) return Promise.resolve(cart);
    if (!hasUpsell(cart)) return Promise.resolve(cart);
    if (cleaning) return Promise.resolve(cart);

    cleaning = true;

    var hasXoDom = UPSELL_IDS.some(function (id) {
      var el = document.querySelector('xo-product[xo-product-id="' + id + '"]');
      return el && !el.closest('#SB-CartUpsells, [data-sb-cart-upsells], .sb-cart-upsells');
    });

    if (hasXoDom) {
      return removeAllUpsellsSequential()
        .then(function () { return getCart(); })
        .then(function (c) { cleaning = false; return c; })
        .catch(function () { cleaning = false; return cart; });
    }

    // Fallback khi khong co DOM XO (vd dang o trang khac)
    var updates = {};
    UPSELL_IDS.forEach(function (id) { updates[id] = 0; });
    return updateCart(updates)
      .then(function (newCart) { cleaning = false; return newCart; })
      .catch(function () { cleaning = false; return cart; });
  }

  function syncCartUI() {
    if (syncing) return Promise.resolve();
    syncing = true;

    return getCart()
      .then(function (cart) { return cleanupOnlyUpsells(cart); })
      .then(function (cart) {
        syncUpsellToggles(cart);
        dismissXoLineErrors();
        return cart;
      })
      .catch(function (err) { console.error('[SB Cart V23]', err); })
      .finally(function () { syncing = false; });
  }

  // Poll nhieu lan vi XO remove la bat dong bo: cart tren server co the
  // chua cap nhat ngay khi user click. Lap toi khi state on dinh (2 lan
  // lien tiep giong nhau) hoac het luot.
  function pollSyncUntilStable() {
    var attempts = 0;
    var maxAttempts = 8;
    var lastSignature = null;

    function step() {
      attempts++;
      getCart()
        .then(function (cart) {
          // signature = so item + co con san pham thuong khong
          var sig = (cart.item_count || 0) + ':' + (hasNormalProduct(cart) ? '1' : '0') +
                    ':' + (hasUpsell(cart) ? '1' : '0');

          // neu chi con upsell -> cleanup ngay (cleanupOnlyUpsells co co chong trung)
          return cleanupOnlyUpsells(cart).then(function (after) {
            syncUpsellToggles(after);
            dismissXoLineErrors();

            var afterSig = (after.item_count || 0) + ':' + (hasNormalProduct(after) ? '1' : '0') +
                           ':' + (hasUpsell(after) ? '1' : '0');

            // dieu kien dung: state on dinh va khong con "chi-con-upsell" can don
            var stable = (afterSig === lastSignature);
            var needsMoreCleanup = !hasNormalProduct(after) && hasUpsell(after);

            lastSignature = afterSig;

            if (cleaning || needsMoreCleanup || (!stable && attempts < maxAttempts)) {
              setTimeout(step, 350);
            }
          });
        })
        .catch(function () {
          if (attempts < maxAttempts) setTimeout(step, 350);
        });
    }

    step();
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      pollSyncUntilStable();
    }, delay || 150);
  }

  // ---------- Add to cart (auto them 3 upsell) ----------
  function getProductForm(btn) {
    var form = btn ? btn.closest('form[action*="/cart/add"]') : null;
    if (!form && btn) {
      var formId = btn.getAttribute('form');
      if (formId) form = document.getElementById(formId);
    }
    return form || document.querySelector('form[action*="/cart/add"]');
  }

  function getMainVariantId(form) {
    var input = form ? form.querySelector('[name="id"]') : null;
    return input ? String(input.value || '').trim() : '';
  }

  function getQuantity(form) {
    var input = form ? form.querySelector('[name="quantity"]') : null;
    var qty = input ? parseInt(input.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  function addHidden(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function copyProperties(sourceForm, targetForm) {
    sourceForm.querySelectorAll('[name^="properties["]').forEach(function (input) {
      if (input.disabled) return;
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      var name = input.getAttribute('name');
      var value = input.value;
      if (!name || value === '' || value == null) return;
      var match = name.match(/^properties\[(.+)\]$/);
      if (!match || !match[1]) return;
      addHidden(targetForm, 'items[0][properties][' + match[1] + ']', value);
    });
  }

  function submitAddWithUpsells(sourceForm) {
    var mainVariantId = getMainVariantId(sourceForm);
    if (!mainVariantId) return false;

    var quantity = getQuantity(sourceForm);

    // Fetch cart truoc de biet upsell nao DA co -> chi them cai con thieu,
    // tranh cong don quantity upsell (chi can 1 cai moi loai).
    getCart()
      .then(function (cart) {
        return (cart && cart.items) ? cart : { items: [] };
      })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var nativeForm = document.createElement('form');
        nativeForm.method = 'post';
        nativeForm.action = '/cart/add';
        nativeForm.style.display = 'none';

        addHidden(nativeForm, 'items[0][id]', mainVariantId);
        addHidden(nativeForm, 'items[0][quantity]', quantity);
        copyProperties(sourceForm, nativeForm);

        var idx = 1;
        UPSELL_IDS.forEach(function (id) {
          // chi them neu upsell nay CHUA co trong cart
          if (!findCartItem(cart, id)) {
            addHidden(nativeForm, 'items[' + idx + '][id]', id);
            addHidden(nativeForm, 'items[' + idx + '][quantity]', 1);
            // gan mo ta de hien thay cho "Default Title"
            if (UPSELL_DESCRIPTIONS[id]) {
              addHidden(nativeForm, 'items[' + idx + '][properties][_desc]', UPSELL_DESCRIPTIONS[id]);
            }
            idx++;
          }
        });

        addHidden(nativeForm, 'return_to', '/cart');
        document.body.appendChild(nativeForm);
        nativeForm.submit();
      });

    return true;
  }

  // ---------- Toggle upsell trong widget cua minh (drawer / cart) ----------
  // Bat  = them upsell qua /cart/add.js
  // Tat  = click nut xo-cart-remove cua dung dong do (XO tu cap nhat total)
  function addUpsell(id) {
    var item = { id: id, quantity: 1 };
    if (UPSELL_DESCRIPTIONS[id]) {
      item.properties = { _desc: UPSELL_DESCRIPTIONS[id] };
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) { return res.json(); });
  }

  // Lay section id cua main cart tu xo-cart (vd template--xxx__cart-items)
  function getCartSectionId() {
    var cart = document.querySelector('xo-cart[id], xo-cart');
    return cart ? (cart.id || cart.getAttribute('id') || '') : '';
  }

  // Lay section id cua drawer (xo-cart-mini) neu co
  function getDrawerSectionId() {
    var mini = document.querySelector('xo-cart-mini[id], xo-cart-mini');
    if (mini && mini.id) return mini.id;
    // mot so theme dat id o cha
    var p = mini ? mini.parentElement : null;
    for (var i = 0; i < 4 && p; i++) {
      if (p.id && /cart|mini|drawer/i.test(p.id)) return p.id;
      p = p.parentElement;
    }
    return '';
  }

  function fetchSection(sectionId) {
    return fetch('/?sections=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (data) { return data && data[sectionId]; })
      .catch(function () { return null; });
  }

  function replaceSectionHtml(sectionId, html) {
    if (!html) return false;
    var el = document.getElementById(sectionId);
    if (!el) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#' + CSS.escape(sectionId)) || tmp.firstElementChild;
    if (fresh) {
      el.innerHTML = fresh.innerHTML;
      return true;
    }
    return false;
  }

  // Re-render CA main cart va drawer cung luc bang Section Rendering API.
  // Phai dong bo ca hai, neu khong xo-line giua main cart va drawer se lech
  // -> bam Remove o drawer se xoa nham dong.
  function rerenderCartSections() {
    var mainId = getCartSectionId();
    var drawerId = getDrawerSectionId();

    var ids = [];
    if (mainId) ids.push(mainId);
    if (drawerId && drawerId !== mainId) ids.push(drawerId);
    if (!ids.length) return Promise.resolve(false);

    // mot request lay ca 2 section
    return fetch('/?sections=' + encodeURIComponent(ids.join(',')), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data) return false;
        ids.forEach(function (id) {
          if (data[id]) replaceSectionHtml(id, data[id]);
        });
        return true;
      })
      .catch(function () { return false; });
  }

  function removeUpsellViaXo(id) {
    var prod = document.querySelector('xo-product[xo-product-id="' + id + '"]');
    if (prod && !prod.closest('#SB-CartUpsells, [data-sb-cart-upsells], .sb-cart-upsells')) {
      var remove = prod.querySelector('xo-cart-remove, [xo-cart-remove], .xo-cart-remove');
      if (remove) {
        return new Promise(function (resolve) {
          var done = false;
          function finish() { if (done) return; done = true; if (mo) mo.disconnect(); clearTimeout(t); resolve(true); }
          var mo = null;
          try {
            mo = new MutationObserver(function () { if (!document.body.contains(prod)) finish(); });
            mo.observe(document.body, { childList: true, subtree: true });
          } catch (e) {}
          var t = setTimeout(finish, 700);
          remove.click();
        });
      }
    }
    // khong co DOM XO -> fallback update.js
    var updates = {}; updates[id] = 0;
    return updateCart(updates).then(function () { return true; });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest(
      '#SB-CartUpsells [data-upsell-toggle], ' +
      '[data-sb-cart-upsells] [data-upsell-toggle], ' +
      '.sb-cart-upsells [data-upsell-toggle]'
    );
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var row = toggle.closest('[data-upsell-item]');
    if (!row) return;

    var id = String(row.getAttribute('data-variant-id') || '').trim();
    if (!isUpsellId(id)) return;

    var shouldAdd = !row.classList.contains('is-active');
    row.classList.toggle('is-active', shouldAdd);

    var action = shouldAdd ? addUpsell(id) : removeUpsellViaXo(id);

    action
      .then(function () {
        // khi BAT (add qua /cart/add.js), XO chua ve dong moi
        // -> re-render CA main cart + drawer de dong bo xo-line (tranh xoa nham)
        if (shouldAdd) return rerenderCartSections();
        return false;
      })
      .then(function () { return getCart(); })
      .then(function (cart) { return cleanupOnlyUpsells(cart); })
      .then(function () { return getCart(); })
      .then(function (cart) {
        syncUpsellToggles(cart);
        updateTotals(cart);
        updateBadge(cart);
        dismissXoLineErrors();
        return cart;
      })
      .catch(function () { scheduleSync(100); });
  }, true);

  // ---------- Add-to-cart ----------
  // document.addEventListener('click', function (event) {
  //   var btn = event.target.closest(
  //     '#an-add-to-cart, [data-js-product-button-add-to-cart], ' +
  //     '.js_add_to_cart_button, button[type="submit"], input[type="submit"]'
  //   );
  //   if (!btn) return;
  //   if (isCartPage()) return;
  //   if (btn.closest('#SB-CartUpsells, [data-sb-cart-upsells], .sb-cart-upsells')) return;
  //   if (addSubmitting) return;
  
  //   if (typeof window.validateProductForm === 'function') {
  //     if (window.validateProductForm(event) === false) {
  //       event.preventDefault();
  //       event.stopImmediatePropagation();
  //       return;
  //     }
  //   }
  //   var form = getProductForm(btn);
  //   if (!form) return;
  //   var action = form.getAttribute('action') || '';
  //   if (action.indexOf('/cart/add') === -1) return;
  //   var variantId = getMainVariantId(form);
  //   if (!variantId) return;

  //   addSubmitting = true;
  //   event.preventDefault();
  //   event.stopPropagation();
  //   event.stopImmediatePropagation();
  //   submitAddWithUpsells(form);
  // }, true);

  // document.addEventListener('submit', function (event) {
  //   if (isCartPage()) return;
  //   if (addSubmitting) return;
  //   var form = event.target;
  //   if (!form || !form.matches('form[action*="/cart/add"]')) return;
  //   addSubmitting = true;
  //   event.preventDefault();
  //   event.stopPropagation();
  //   event.stopImmediatePropagation();
  //   submitAddWithUpsells(form);
  // }, true);

  // ---------- Remove / qty change: sau khi XO xu ly, kiem tra cleanup ----------
  document.addEventListener('click', function (event) {
    var xoAction = event.target.closest(
      'xo-cart-remove, [xo-cart-remove], .xo-cart-remove, ' +
      'xo-cart-quantity-minus, xo-cart-quantity-plus, ' +
      'a[href*="/cart/change"], a[href*="quantity=0"], ' +
      'button[name="remove"], .remove, .cart-remove-button, ' +
      '[data-cart-remove], [data-remove], [data-js-cart-remove], ' +
      'button[name="plus"], button[name="minus"], ' +
      '[data-js-cart-update], quantity-input button'
    );
    if (!xoAction) return;
    // de XO xu ly truoc, roi minh check con-mot-san-pham
    scheduleSync(450);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest(
      'input[name="updates[]"], input[name^="updates"], input[type="number"]'
    );
    if (!input) return;
    scheduleSync(450);
  }, true);

  ['cart:updated', 'cart:change', 'cart:refresh', 'cart:build', 'cart:open'].forEach(function (name) {
    document.addEventListener(name, function () { scheduleSync(200); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watchForLineErrors();
      syncCartUI();
    });
  } else {
    watchForLineErrors();
    syncCartUI();
  }

  document.addEventListener('shopify:section:load', syncCartUI);
})();